export default __webpack_public_path__ + "static/media/dani.d709daed.jpg";